import {
  GET_EXTERNAL_PROJECTS_LIST_LOADING,
  GET_EXTERNAL_PROJECTS_LIST_SUCCESS,
  GET_EXTERNAL_PROJECTS_LIST_FAILURE,
} from "redux/types";
import { Dispatch } from "redux";
import { listItemsService } from "services/listItemsService";
import { getExternalProjectsListUrl } from "api/apiUrls";

export const getExternalProjectsListActions =
  (categoryId?: number, page?: number, pageSize?: number) =>
  async (dispatch: Dispatch) => {
    try {
      dispatch({ type: GET_EXTERNAL_PROJECTS_LIST_LOADING, payload: true });

      const response: any = await listItemsService(
        `${getExternalProjectsListUrl}/${categoryId}`,
        `page=${page}&pageSize=${pageSize}`
      );

      dispatch({
        type: GET_EXTERNAL_PROJECTS_LIST_SUCCESS,
        payload: response.data,
      });
    } catch (err) {
      dispatch({ type: GET_EXTERNAL_PROJECTS_LIST_FAILURE, payload: err });
    } finally {
      dispatch({ type: GET_EXTERNAL_PROJECTS_LIST_LOADING, payload: false });
    }
  };
